var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "top-left whiteBg" },
      [
        _c("el-card", { staticClass: "box-cards" }, [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [_c("span", [_vm._v("业务待办数量")])]
          ),
          _c("div", { staticClass: "cards-content" }, [
            _c(
              "div",
              { staticClass: "type-num" },
              _vm._l(_vm.dealData, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "type-num-flex",
                    on: {
                      click: function ($event) {
                        return _vm.jumpNode(item.nodeName)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "num-top" }, [
                      _c(
                        "div",
                        [
                          index == 0
                            ? [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/img/home/top_11.png"),
                                    alt: "",
                                  },
                                }),
                              ]
                            : index == 1
                            ? [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/img/home/top_22.png"),
                                    alt: "",
                                  },
                                }),
                              ]
                            : index == 2
                            ? [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/img/home/top_33.png"),
                                    alt: "",
                                  },
                                }),
                              ]
                            : [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/img/home/top_44.png"),
                                    alt: "",
                                  },
                                }),
                              ],
                        ],
                        2
                      ),
                      _c("div", { staticClass: "top-title" }, [
                        _c("span", [_vm._v(_vm._s(item.nodeName))]),
                        _c("span", [_vm._v(_vm._s(item.totalCount))]),
                      ]),
                    ]),
                    _c("div", { staticClass: "num-bottom" }, [
                      _c("div", [
                        _vm._v(" 首次提交 "),
                        _c("span", [_vm._v(_vm._s(item.firstSubmitCount))]),
                      ]),
                      _c("div", [
                        _vm._v(" 退回后提交 "),
                        _c("span", [_vm._v(_vm._s(item.returnCount))]),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
            _c(
              "div",
              { staticClass: "type-table" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.dataListLoading,
                        expression: "dataListLoading",
                      },
                    ],
                    ref: "multipleTable",
                    staticClass: "table-content hide-scrollbar",
                    attrs: {
                      data: _vm.tableData,
                      "header-cell-style": this.$globalGrayTableHeaderStyle,
                      height: 251,
                      stripe: "",
                    },
                    on: { "filter-change": _vm.filterChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        index: _vm.indexMethod,
                        align: "center",
                        fixed: "",
                        label: "序号",
                        type: "index",
                        width: "50",
                        "show-overflow-tooltip": true,
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: `项目/${
                          _vm.filters.field4 == "其他" ? "任务" : "标段"
                        }名称`,
                        prop: "field3",
                        "header-align": "left",
                        align: "left",
                        "min-width": "200",
                        "show-overflow-tooltip": true,
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: `项目/${
                          _vm.filters.field4 == "其他" ? "任务" : "标段"
                        }编号`,
                        prop: "field2",
                        "header-align": "left",
                        align: "left",
                        "min-width": "180",
                        "show-overflow-tooltip": true,
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        filters: _vm.flowNameData,
                        label: "业务节点",
                        prop: "field4",
                        "header-align": "left",
                        align: "left",
                        "min-width": "100",
                        "show-overflow-tooltip": true,
                      },
                    }),
                    _c("el-table-column", {
                      attrs: {
                        label: "提交时间",
                        sortable: "",
                        prop: "fromTime",
                        "header-align": "center",
                        align: "center",
                        "min-width": "100",
                        "show-overflow-tooltip": true,
                      },
                    }),
                    _vm.hasBtnPermission("supperviseion_home_to_todo_btn")
                      ? _c("el-table-column", {
                          attrs: {
                            align: "center",
                            label: "操作",
                            width: "200",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          type: "text",
                                          size: "small",
                                          title: "查看",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.jump(scope.row)
                                          },
                                        },
                                      },
                                      [_vm._v("查看")]
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            3389270441
                          ),
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _c("paginationCom", {
                  staticClass: "limit",
                  attrs: { options: _vm.paginationOpt },
                  on: {
                    sizechange: _vm.sizeChangeHandle,
                    pagechange: _vm.pageChangeHandle,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ],
      1
    ),
    _c("div", { staticClass: "top-right" }, [
      _c("div", { staticClass: "cards-content" }, [
        _c("div", { staticClass: "video-num" }, [
          _c(
            "div",
            {
              staticClass: "video-padding",
              on: {
                click: function ($event) {
                  return _vm.jump1(1)
                },
              },
            },
            [
              _vm._m(0),
              _c("div", { staticClass: "video-content topbg" }, [
                _c("div", [
                  _c("span", { staticClass: "firstSpan" }, [
                    _vm._v(_vm._s(_vm.bidOpenCountObj.bidOpenTodayCount || 0)),
                  ]),
                  _vm._v(" 宗 "),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "video-padding avrage left",
              on: {
                click: function ($event) {
                  return _vm.jump1(1)
                },
              },
            },
            [
              _c("div", { staticClass: "video-title" }, [_vm._v("本周待开标")]),
              _c("div", { staticClass: "video-content" }, [
                _c("div", [
                  _c("span", [
                    _vm._v(_vm._s(_vm.bidOpenCountObj.bidopenWeekCount || 0)),
                  ]),
                  _vm._v(" 宗 "),
                ]),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "video-padding avrage",
              on: {
                click: function ($event) {
                  return _vm.jump1(1)
                },
              },
            },
            [
              _c("div", { staticClass: "video-title" }, [_vm._v("本月待开标")]),
              _c("div", { staticClass: "video-content" }, [
                _c("div", [
                  _c("span", [
                    _vm._v(_vm._s(_vm.bidOpenCountObj.bidopenMonthCount || 0)),
                  ]),
                  _vm._v(" 宗 "),
                ]),
              ]),
            ]
          ),
        ]),
        _c("div", { staticClass: "system-jump" }, [
          _c("div", { staticClass: "top_systemInto" }, [
            _c(
              "div",
              {
                staticClass: "leftInto",
                on: {
                  click: function ($event) {
                    return _vm.jump1(7)
                  },
                },
              },
              [_vm._m(1)]
            ),
            _c(
              "div",
              {
                staticClass: "rightInto",
                on: {
                  click: function ($event) {
                    return _vm.jump1(1)
                  },
                },
              },
              [_vm._m(2)]
            ),
          ]),
          _c("div", { staticClass: "top-middle-right" }, [
            _c("div", { ref: "numblue", staticClass: "num-blue projectAll" }, [
              _c(
                "div",
                {
                  staticClass: "blueNum_bg",
                  style: { width: _vm.numBlueLeftWidth },
                  on: {
                    click: function ($event) {
                      return _vm.jump("businessWitnessHis", 1)
                    },
                  },
                },
                [
                  _c("div", [_vm._v("已完结项目")]),
                  _c("div", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.projectCountData.finishCount)),
                    ]),
                    _vm._v(" 宗 "),
                  ]),
                ]
              ),
              _c("div", {
                staticClass: "content",
                style: { left: _vm.numWhiteLeftWidth },
              }),
              _c(
                "div",
                {
                  staticClass: "grayNum_bg",
                  style: { width: _vm.numGrayrightWidth },
                  on: {
                    click: function ($event) {
                      return _vm.jump("businessWitnessHis", 2)
                    },
                  },
                },
                [
                  _c("div", [_vm._v("未完结项目")]),
                  _c("div", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.projectCountData.notFinishCount)),
                    ]),
                    _vm._v(" 宗 "),
                  ]),
                ]
              ),
            ]),
            _c("div", { staticClass: "handle_count" }, [
              _c(
                "div",
                {
                  staticClass: "num-yellow",
                  on: {
                    click: function ($event) {
                      return _vm.jump1(7)
                    },
                  },
                },
                [
                  _c("div", [_vm._v("待处理投诉数量")]),
                  _c("div", [
                    _c("span", [
                      _vm._v(_vm._s(_vm.projectCountData.receiveCount)),
                    ]),
                    _vm._v("宗 "),
                  ]),
                  _c("img", {
                    staticStyle: { width: "56px", height: "56px" },
                    attrs: {
                      src: require("@/assets/img/home/complaint.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "num_red",
                  on: {
                    click: function ($event) {
                      return _vm.jump1(7, { tabActived: "all", dateRange: 30 })
                    },
                  },
                },
                [
                  _c("div", [_vm._v("近30日投诉")]),
                  _c("div", [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.projectCountData.nearlyMonthReportCount || 0)
                      ),
                    ]),
                    _vm._v("条 "),
                  ]),
                  _c("img", {
                    attrs: { src: require("@/assets/img/light.png"), alt: "" },
                  }),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "video-title" }, [
      _c("img", {
        staticClass: "datePng",
        attrs: { src: require("@/assets/img/date.png"), alt: "" },
      }),
      _c("span", { staticClass: "title_text" }, [_vm._v("今日开标项目")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "left_margin" }, [
      _c("div", [_vm._v("项目投诉")]),
      _c("div", [_vm._v("监管入口")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "left_margin" }, [
      _c("div", [_vm._v("项目开评标音视频")]),
      _c("div", [_vm._v("监管入口")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }